/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button, Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBars,
  faVolumeXmark,
  faVolumeHigh,
} from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function IntroWith320HDynamicPreview({
  srcs,
  resetKey,
  redirectImage,
  redirectVideo,
}) {
  const validImages = Array.isArray(srcs) ? srcs.filter((src) => src.file) : []
  const [showIntro, setShowIntro] = React.useState(true)
  const [showContent, setShowContent] = React.useState(false)
  const [isMuted, setIsMuted] = React.useState(true)
  const bottomVideoRef = React.useRef(null)

  const IntroVideo = srcs.find((s) => s.label === 'Intro video')
  const BottomVideo = srcs.find((s) => s.label === 'Bottom video')
  const MainImg = srcs.find((s) => s.label === 'Top img')
  const isVideo = (entry) => {
    if (!entry) return false

    if (typeof entry.type === 'string') {
      return entry.type.startsWith('video')
    }

    if (typeof entry.file === 'string') {
      return entry.file.endsWith('.mp4') || entry.file.startsWith('blob:')
    }

    return false
  }

  const getPreviewURL = (file) => {
    if (file instanceof File || file instanceof Blob) {
      return URL.createObjectURL(file)
    }
    if (typeof file === 'string') {
      return file
    }
    return ''
  }

  useEffect(() => {
    if (!showIntro) return undefined

    const timer = setTimeout(() => {
      setShowIntro(false)
      setShowContent(true)
    }, 3500)

    return () => {
      clearTimeout(timer)
    }
  }, [showIntro])

  useEffect(() => {
    setShowIntro(true)
    setShowContent(false)
  }, [resetKey])

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '2%' }}
        />
        <div style={{ position: 'relative' }}>
          <div
            className="border-bottom mb-3 d-flex"
            style={{ width: '240px', height: '55px', zIndex: '0' }}
          >
            <div className="w-80 m-auto ms-auto">
              <Image src={wavenet_logo} className="w-75 ps-3" />
            </div>
            <div className="w-20 m-auto ms-auto d-flex">
              <FontAwesomeIcon icon={faBars} className="text-end" />
            </div>
          </div>
          <div className="text-title" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-ban1" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line2" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
        </div>
      </div>

      {showIntro && IntroVideo?.file && (
        <div
          className="position-absolute"
          style={{
            width: '240px',
            right: '19.1%',
            maxHeight: '360px',
            overflow: 'hidden',
            bottom: '11%',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'flex-end',
          }}
        >
          {isVideo(IntroVideo) ? (
            <>
              <video
                src={getPreviewURL(IntroVideo.file)}
                autoPlay
                muted
                controls
                playsInline
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              <CIIcon />
            </>
          ) : (
            <>
              <img
                src={getPreviewURL(IntroVideo.file)}
                alt="Intro"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              <CIIcon />
            </>
          )}
        </div>
      )}

      {showContent && MainImg?.file && (
        <div
          className="position-absolute"
          style={{
            bottom: '10%',
            width: '240px',
            right: '19.1%',
            height: 'auto',
            zIndex: 1000,
          }}
        >
          <div
            role="presentation"
            onClick={() => {
              if (redirectImage) window.open(redirectImage, '_blank')
            }}
            style={{ cursor: 'pointer' }}
          >
            {MainImg.file.type?.startsWith('video') ? (
              <>
                <video
                  ref={bottomVideoRef}
                  src={getPreviewURL(MainImg.file)}
                  autoPlay
                  muted
                  controls
                  loop
                  playsInline
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
                <div
                  role="presentation"
                  onClick={(e) => {
                    e.stopPropagation()
                    setIsMuted((prev) => {
                      const newMuted = !prev
                      if (bottomVideoRef.current) {
                        bottomVideoRef.current.muted = newMuted
                      }
                      return newMuted
                    })
                  }}
                  style={{
                    position: 'absolute',
                    left: '5px',
                    bottom: '5px',
                    zIndex: 1100,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    borderRadius: '50%',
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <FontAwesomeIcon
                    icon={isMuted ? faVolumeXmark : faVolumeHigh}
                    style={{ color: 'white', fontSize: '18px' }}
                  />
                </div>
              </>
            ) : (
              <img
                src={getPreviewURL(MainImg.file)}
                alt="Main"
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            )}
          </div>
          <Button
            onClick={() => setShowContent(false)}
            style={{
              position: 'absolute',
              top: '-30px',
              right: '6px',
              border: 'none',
              borderRadius: '50%',
              background: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1501,
              height: '23px',
              width: '23px',
              fontSize: '12px',
              padding: '2px',
            }}
          >
            ✕
          </Button>
        </div>
      )}

      {showContent && BottomVideo?.file && (
        <div
          role="presentation"
          className="position-absolute"
          onClick={() => {
            if (redirectVideo) window.open(redirectVideo, '_blank')
          }}
          style={{
            bottom: '10%',
            width: '100%',
            maxHeight: '135px',
            overflow: 'hidden',
            zIndex: 1001,
            pointerEvents: 'auto',
            cursor: redirectVideo ? 'pointer' : 'default',
            position: 'relative', // 這裡加上 relative
          }}
        >
          <video
            ref={bottomVideoRef}
            src={getPreviewURL(BottomVideo.file)}
            autoPlay
            muted={isMuted}
            loop
            playsInline
            style={{
              width: '240px',
              height: 'auto',
              objectFit: 'cover',
              zIndex: '1001',
            }}
          >
            <track kind="captions" srcLang="en" src="" default />
          </video>

          <div
            role="presentation"
            onClick={(e) => {
              e.stopPropagation()
              setIsMuted((prev) => {
                const newMuted = !prev
                if (bottomVideoRef.current) {
                  bottomVideoRef.current.muted = newMuted
                }
                return newMuted
              })
            }}
            style={{
              position: 'absolute',
              left: '5px',
              bottom: '5px',
              zIndex: 1100,
              backgroundColor: 'rgba(0,0,0,0.5)',
              borderRadius: '50%',
              width: '30px',
              height: '30px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              opacity: '0.8',
            }}
          >
            <FontAwesomeIcon
              icon={isMuted ? faVolumeXmark : faVolumeHigh}
              style={{ color: 'white', fontSize: '18px' }}
            />
          </div>
        </div>
      )}
    </div>
  )
}

IntroWith320HDynamicPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  resetKey: PropTypes.number,
  redirectImage: PropTypes.string,
  redirectVideo: PropTypes.string,
}

IntroWith320HDynamicPreview.defaultProps = {
  srcs: [],
  resetKey: 0,
  redirectImage: '',
  redirectVideo: '',
}

export default IntroWith320HDynamicPreview
